const PrivacyPolicy = `
Privacy Policy - Full Trucking ServiceLast Updated: [14.03.2025]



Welcome to Full Trucking Service. Your privacy and the security of your data are of the utmost importance to us. This Privacy Policy outlines how we collect, use, store, disclose, and protect your personal and business information when you use our platform.
By accessing or using Full Trucking Service, you agree to the terms outlined in this Privacy Policy. If you do not agree, you must discontinue use of our services.
This policy applies to all trucking companies, dispatchers, accountants, and authorized users of the platform across the United States, Canada, and South America.



<h2>1. Compliance with Data Protection Laws</h2>


Full Trucking Service operates in compliance with:
The General Data Protection Regulation (GDPR) for users in the European Union.
The California Consumer Privacy Act (CCPA) for users in the United States.
Other relevant privacy laws applicable in Canada, South America, and international jurisdictions.
Users have rights regarding their data as outlined in these regulations.



<h2>2. Information We Collect</h2>
We collect different types of information, depending on how you interact with our platform.


<h3>2.1 Information Provided by You</h3>
Business Information: Company name, registered address, MC Number, USDOT registration, IFTA license, fleet size, operational areas.
Account Holder Information: Name, business email, phone number, and role within the company.
Financial Information: Payment details, subscription preferences, transaction history.
Support & Communications: Messages, inquiries, and survey responses.


<h3>2.2 Information We Collect Automatically</h3>
Device & Usage Information: Browser type, IP address, session durations, system interactions.
Location Data: GPS tracking for fleet monitoring (if enabled by users).
System Analytics: Dispatch activity, payroll processing, fuel tax calculations.


<h3>2.3 Information from Third Parties</h3>
Business verification data from government agencies (USDOT, FMCSA, IFTA).
Fraud prevention checks from financial institutions.



<h2>3. How We Use Your Information</h2>
We use collected data for the following purposes:

<h3>3.1 Service Delivery & Account Management</h3>
To create and manage your Full Trucking Service account.
To verify business legitimacy and ensure compliance with transport regulations.

<h3>3.2 Payment Processing & Subscription Management</h3>
To securely process payments, invoices, and renewals.
To prevent fraudulent transactions and comply with financial regulations.

<h3>3.3 Customer Support & Communication</h3>
To assist with technical troubleshooting and service inquiries.
To send billing notifications, security alerts, and legal updates.

<h3>3.4 Platform Optimization & Analytics</h3>
To analyze user behavior and improve service functionality.
To optimize dispatching, route management, and fuel tracking.

<h3>3.5 Legal Compliance & Security Enforcement</h3>
To comply with transportation laws and regulations.
To investigate and prevent fraud, security breaches, or violations of law.


<h2>4. How We Share Your Information</h2>
We do not sell or rent your personal data. However, we share data under the following conditions:

<h3>4.1 With Trusted Service Providers</h3>
Payment processing (e.g., Stripe, PayPal, banking institutions).
Cloud hosting and cybersecurity protection providers.

<h3>4.2 Legal & Regulatory Disclosures</h3>
Compliance with court orders, government requests, and regulatory audits.
Reporting fraudulent transactions or financial crimes when required by law.

<h3>4.3 Business Mergers or Transfers</h3>
If Full Trucking Service undergoes a merger, acquisition, or business restructuring, user data may be transferred to a new entity.

<h2>5. Data Storage & Security Measures</h2>

<h3>5.1 Data Encryption & Protection</h3>
All sensitive data is encrypted using AES-256 encryption.
Secure HTTPS protocols are enforced for all transactions.

</h3>5.2 Data Retention Policy</h3>
Data is stored as long as the account is active.
Upon account termination, all personal data is deleted after 12 months, except for records required for tax and legal compliance.

<h3>5.3 Security Breach Response</h3>
Users will be notified within 72 hours in the event of a data breach.
Immediate action will be taken to secure affected accounts.


<h2>6. Your Rights & Control Over Data</h2>
Users have the following rights regarding their data:
Access & Correction: Users can request access to their data and correct inaccuracies.
Data Deletion Requests: Users can request deletion of their data, subject to compliance requirements.
Marketing Preferences: Users can opt out of marketing emails anytime.
Portability: Users can request a copy of their data in a structured format.


<h2>7. Cookies & Tracking Technologies</h2>

<h3>7.1 Use of Cookies</h3>
We use cookies to enhance platform functionality and improve user experience.
Users can disable cookies in their browser settings, but some features may become unavailable.

<h3>7.2 Third-Party Tracking</h3>
We may integrate with Google Analytics and other third-party tools for service optimization.


<h2>8. Third-Party Integrations</h2>
Our platform may contain links to third-party compliance tools and financial services.
We are not responsible for privacy policies of third-party sites.


<h2>9. Children’s Privacy</h2>
Full Trucking Service does not knowingly collect data from individuals under 18 years old.
If we discover that a minor has registered, their data will be deleted immediately.


<h2>10. Changes to this Privacy Policy</h2>
We reserve the right to update this Privacy Policy as needed.
Policy updates will be communicated via email.
Continued use of our services constitutes agreement to the updated terms.

<h2>11. Contact Information</h2>
If you have any privacy-related inquiries, please contact us:

📧 Email: support@fulltruckingservice.com

By using Full Trucking Service, you confirm that you have read, understood, and agreed to this Privacy Policy.

`;

export default PrivacyPolicy;